export default "__VITE_ASSET__D4xgdG$4__"